import React from 'react';

import { StyleSheet } from 'react-native';

import Link from 'components/link';
import { Box } from 'components/ui';
import { primitive } from 'styles/constants';

export const StyledLink = Link.withConfig({
  borderBottomWidth: '1px',
  borderStyle: 'solid',
  borderBottomColor: `${primitive.$greyFour}`,
  width: '100%',
  color: primitive.$greyOne,
  paddingX: '0',
  paddingY: '5',
  _web: {
    cursor: 'pointer',
  },
});

export const Row = ({ children }: React.PropsWithChildren) =>
  React.createElement(Box, { style: styles.row }, children);

const styles = StyleSheet.create({
  row: {
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
  },
});
